// extracted by mini-css-extract-plugin
export default {"modal":"Modal-module__modal__OBR2P","modal-overlay":"Modal-module__modal-overlay__IaD1A","hr-desktop":"Modal-module__hr-desktop__hkXtk","hr-mobile":"Modal-module__hr-mobile__G4Vh8"};